export default __webpack_public_path__ + "static/dgpay-plus-logo-02ba28166f4bd1260b418fb34a1796ce.svg";